import script from "./X1Datatable.vue?vue&type=script&lang=ts&setup=true"
export * from "./X1Datatable.vue?vue&type=script&lang=ts&setup=true"

import "./X1Datatable.vue?vue&type=style&index=0&id=4d3dac9e&lang=scss&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d3dac9e"]])

export default __exports__